import { Modal, Text } from "@mantine/core"
import { useUserAuth } from "../../contexts/user.context";

const ErrorModal = () => {

    const {userError} = useUserAuth();

    return (
        <Modal
            onClose = {() => {}}
            closeOnClickOutside = {false}
            closeOnEscape = {false}
            centered = {true}
            opened={userError}
            title="We've encountered an error 😕"
            size='lg'
            radius = 'lg'
            withCloseButton = {false}
            styles = {{
                title: {
                    fontWeight:'600',
                    fontSize:'20px',
                }
            }}
        >
            <Text>
                There was a problem accessing your account. If this error persists, contact support and we'll resolve the issue as soon as possible.
            </Text>
        </Modal>
    )
}

export default ErrorModal;